import image from 'assets/image/snail-looking-for.png'
import clsx from 'clsx'
import { CONSTS } from 'config/objectConst'
import { typo } from 'shared/styles'
import { Button, StackIcon } from 'shared/ui'

import css from './NotExistYet.module.css'

export const NotExistYet = ({ className }: { className?: string }) => (
	<article className={clsx(css.root, className)}>
		<h2 className={clsx(typo.subtitle, css.title)}>
			Ooops… No contacts to add!
		</h2>
		<img alt='snail' className={css.image} src={image} width={150} />
		<Button
			as='a'
			className={css.search}
			href={CONSTS.LINKEDIN_URL}
			rel='noopener noreferrer'
			target='_blank'
			typography={typo.largeButton}
		>
			Search on
			<StackIcon icon='linked' width={18} />
		</Button>
	</article>
)
